import { useState, useCallback } from 'react'

const SOFT_ASK_KEY = 'push-soft-ask-dismissed'
const SEVEN_DAYS_MS = 7 * 24 * 60 * 60 * 1000

function shouldShow(): boolean {
  if (typeof Notification === 'undefined') return false
  if (Notification.permission !== 'default') return false
  const dismissed = localStorage.getItem(SOFT_ASK_KEY)
  if (!dismissed) return true
  const dismissedAt = parseInt(dismissed, 10)
  return Date.now() - dismissedAt > SEVEN_DAYS_MS
}

export function useSoftAsk() {
  const [visible, setVisible] = useState(() => shouldShow())

  const dismiss = useCallback(() => {
    localStorage.setItem(SOFT_ASK_KEY, String(Date.now()))
    setVisible(false)
  }, [])

  const hide = useCallback(() => {
    setVisible(false)
  }, [])

  return { visible, dismiss, hide }
}
